import { render, staticRenderFns } from "./CanteenMap.vue?vue&type=template&id=571ba194&"
import script from "./CanteenMap.vue?vue&type=script&lang=js&"
export * from "./CanteenMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports